"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEGMENT_OFF = exports.SEGMENT_ON = void 0;
exports.Segmented = Segmented;
const jsx_runtime_1 = require("react/jsx-runtime");
const cn_1 = require("../lib/cn");
const tooltip_1 = require("./tooltip");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ ⚠️⚠️ THE CHOSEN PILL, IN BOTH THEMES — 5 Nov 2026.                        │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Light: the page's white on the muted track, as the mockup draws it. ⚠️ **Dark: NOT `--background`**,
 * which is the darkest surface in every dark theme — the chosen pill came out DARKER than its track
 * and read as a hole, and on a card as nothing at all (*"the toggle pills have invisible
 * backgrounds"*). shadcn's own answer, `bg-input/30`, fails here too: in the Catppuccin themes
 * `--input` IS the track's colour. A tint of the foreground is lighter than the track in every dark
 * theme by construction, and the faint ring gives it an edge.
 *
 * ⚠️ **Exported, because three controls draw this pill** — `Segmented`, the list card's view switch
 * and the effort chart's — and three copies of a class string are how one of them stayed dark.
 */
exports.SEGMENT_ON = 'bg-background text-foreground shadow-xs dark:bg-foreground/12 dark:shadow-none dark:ring-1 dark:ring-foreground/15';
exports.SEGMENT_OFF = 'text-muted-foreground enabled:hover:text-foreground';
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ 16 Oct 2026 · Two or three ways of looking at the same thing.             │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * *Heti / Havi* on Időrögzítés, *Nap / Hét / Hónap* and *Kumulatív / Időszakos* on the finance
 * chart. The mockups draw it identically everywhere — a muted track, 24 px buttons, the chosen
 * one lifted onto the background — and the product had grown a private copy per screen. The
 * design system has no component for it, so the mockup's own drawing is the specification.
 *
 * ⚠️ **`aria-pressed` buttons in a `group`, not tabs.** Tabs own a panel each; this changes how
 * ONE panel is drawn, which is a pressed toggle.
 */
function Segmented({ value, options, onChange, label, className, disabled = false, }) {
    return ((0, jsx_runtime_1.jsx)("div", { role: "group", "aria-label": label, className: (0, cn_1.cn)('bg-muted flex shrink-0 items-center gap-0.5 rounded-md p-0.5', disabled && 'opacity-60', className), "data-segmented": true, children: options.map((option) => {
            const button = ((0, jsx_runtime_1.jsx)("button", { type: "button", disabled: disabled, "aria-pressed": value === option.value, className: (0, cn_1.cn)('h-6 rounded px-2 text-[11.5px] font-medium transition-colors disabled:cursor-default', value === option.value ? exports.SEGMENT_ON : exports.SEGMENT_OFF), onClick: () => {
                    onChange(option.value);
                }, children: option.label }, option.value));
            return option.hint === undefined ? (button) : ((0, jsx_runtime_1.jsx)(tooltip_1.Tooltip, { asChild: true, width: 240, content: option.hint, children: button }, option.value));
        }) }));
}
//# sourceMappingURL=segmented.js.map